<template>
    <div class="modal fade" :id="id" tabindex="-1" :data-bs-backdrop="backdrop" aria-hidden="true">
        <div :class="modalClass">
            <div class="modal-content">
                <slot name="header" v-if="showTitle">
                    <div class="modal-header">
                        <slot name="title">
                            <h3 class="modal-title mb-0">
                                <i v-if="icon" class="me-2 opacity-75" :class="icon"></i>
                                <span v-html="title.text ?? title ?? ''"></span>
                            </h3>
                        </slot>
                        <button v-if="closeable" type="button" @click.prevent="close()" class="btn-close"></button>
                    </div>
                </slot>
                <div :class="['modal-body', !showTitle ? 'p-lg-0' : '']" v-if="openModal">
                    <slot></slot>
                </div>
                <div class="modal-footer py-0">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventFormHead from "../../modules/Planners/atoms/EventFormHead.vue";
import {randomString} from "../../services/Defaults";

export default {
    name: "Modal",
    components: {EventFormHead},
    props: {
        id: {
            type: String,
            required: false,
            default() {
                return randomString();
            }
        },
        title: {
            type: String | Object,
            required: false,
            default() {
                return ''
            }
        },
        value: {
            type: Boolean,
            required: false,
            default() {
                return false
            }
        },
        closeable: {
            type: Boolean,
            required: false,
            default() {
                return true
            }
        },
        cls: {
            type: String,
            required: false,
            default() {
                return ''
            }
        },
        size: {
            type: String,
            required: false,
            default() {
                return 'lg'
            },
        },
        fullscreenCls: {
            type: String,
            required: false,
            default() {
                return 'modal-fullscreen-lg-down'
            }
        },
        icon: {
            type: String,
            required: false,
        },
        backdrop: {
            type: Boolean | String,
            required: false,
            default() {
                return true
            }
        },
        showTitle: {
            type: Boolean,
            required: false,
            default() {
                return true
            }
        },
    },
    watch: {
        value: function (val) {
            val === true ? this.open() : this.close();
        },
        openModal: function (val) {
            this.$emit('input', val);
        },
    },
    computed: {
        modalClass() {
            return `modal-dialog modal-dialog-centered ${this.fullscreenCls} modal-${this.size} ${this.cls}`;
        },
    },
    data() {
        return {
            openModal: this.value,
            modal: null,
        }
    },
    methods: {
        open() {
            this.openModal = true;
            this.modal.show();
        },
        close() {
            this.openModal = false;
            this.modal.hide();
        },
        initEvents() {
            const modalElement = document.getElementById(this.id);
            let modalOptions = {};

            if (!this.backdrop || this.backdrop === 'false') {
                modalOptions.backdrop = false;
            }

            this.modal = new bootstrap.Modal(modalElement, modalOptions);

            modalElement.addEventListener('show.bs.modal', (event) => {
                this.$emit('show', event)
                this.$emit('open', event)
            });
            modalElement.addEventListener('shown.bs.modal', (event) => this.$emit('shown', event));
            modalElement.addEventListener('hide.bs.modal', (event) => {
                this.openModal = false;
                this.$emit('hide', event)
                this.$emit('close', event)
            });
            modalElement.addEventListener('hidden.bs.modal', (event) => this.$emit('hidden', event));
            modalElement.addEventListener('hidePrevented.bs.modal', (event) => this.$emit('hidePrevented', event));
        },
    },
    mounted() {
        this.initEvents();
    },
}
</script>

<style scoped>
.modal-body {
    margin: 5px 0;
}
</style>
